<template>
  <svg viewBox="0 0 21 14"><path fill-rule="nonzero" d="M19.197.243a.75.75 0 011.175.927l-.07.087-11 12a.75.75 0 01-.959.123l-.087-.066-8-7a.75.75 0 01.9-1.195l.088.067 7.448 6.517L19.197.243z" /></svg>
</template>


<script>
export default {
  name: 'Confirm'
}
</script>
